import React from 'react'
import { BlueConicRecommendedNotificationParams } from '@pushly/models/lib/structs/journeys'
import { BlueConicRecommendationConfiguration } from '@pushly/models/lib/structs/journeys/steps/send-recommended-notification/blueconic-recommendation-configuration'
import { INDEX_DISPLAY_DEFAULT_ID } from './constants'

export type BlueConicRecommendedNotificationState = {
    source: BlueConicRecommendedNotificationParams
    configs: Map<string, BlueConicRecommendationConfiguration>
}

export type RecommendedNotificationDispatchPack =
    | { type: 'set-configurations'; configurations: BlueConicRecommendationConfiguration[] }
    | { type: 'add-configuration'; recordId: string; configuration: BlueConicRecommendationConfiguration }
    | { type: 'remove-configuration'; recordId: string }
    | { type: 'update-configuration'; recordId: string; configuration: BlueConicRecommendationConfiguration }
    | { type: 'shift-configuration'; recordId: string; ordinalShift: 1 | -1 }

export function blueConicRecommendedNotificationReducer(
    state: BlueConicRecommendedNotificationState,
    action: RecommendedNotificationDispatchPack,
) {
    let nextState = { ...state }

    switch (action.type) {
        case 'add-configuration':
            nextState.configs.set(action.recordId, action.configuration)
            break
        case 'remove-configuration':
            nextState.configs.delete(action.recordId)
            nextState.configs = resetConfigurationIdBasedOnOrder(nextState.configs)
            break
        case 'update-configuration':
            if (nextState.configs.has(action.recordId)) {
                nextState.configs.set(action.recordId, action.configuration)
            }
            break
        case 'shift-configuration':
            if (nextState.configs.has(action.recordId)) {
                const currConfigsArr = Array.from(nextState.configs.entries())
                const currIdx = currConfigsArr.findIndex((c) => c[0] === action.recordId)

                if (currIdx !== -1) {
                    const item = currConfigsArr.splice(currIdx, 1)[0]
                    currConfigsArr.splice(currIdx + action.ordinalShift, 0, item)
                }

                nextState.configs = resetConfigurationIdBasedOnOrder(
                    new Map(currConfigsArr.map(([recordId, config]) => [recordId, config])),
                )
            }
            break
    }

    return nextState
}

function resetConfigurationIdBasedOnOrder(configurations: Map<string, BlueConicRecommendationConfiguration>) {
    let count: number = 0
    configurations.forEach((v, k) => {
        v.id = INDEX_DISPLAY_DEFAULT_ID[count]
        count++
    })

    return configurations
}

export const BlueConicRecommendedNotificationDispatchContext = React.createContext<
    React.Dispatch<RecommendedNotificationDispatchPack>
>(null!)
export const BlueConicRecommendedNotificationContext = React.createContext<BlueConicRecommendedNotificationState>(null!)
